"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MomentTags = exports.MomentRow = exports.MomentAvatars = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _atoms = require("../../atoms");

var _molecules = require("../../molecules");

var _momentRowStar = _interopRequireDefault(require("../../assets/img/moment-row-star.svg"));

var _momentRowStarSelected = _interopRequireDefault(require("../../assets/img/moment-row-star-selected.svg"));

var _ordinalSuffix = require("../../util/ordinalSuffix");

var _ = require("../..");

var _format = require("../../util/format");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
 * This component can show a user's avatar or their initials,
 * size color and border are all customizable.
 */
var MomentRow = function MomentRow(props) {
  var attr = _objectSpread(_objectSpread({}, props), {}, {
    moment: null,
    players: null,
    tags: null,
    highlightPlayer: null,
    expanded: null,
    onClick: null,
    starClick: null,
    tagClick: null,
    userClick: null,
    spotlight: null,
    startTime: null,
    homeColor: null,
    awayColor: null,
    momentInTraceId: null
  });

  var cn = "MomentRow";

  if (props.expanded) {
    cn += " expanded";
  }

  var onClick = function onClick(e) {
    e.preventDefault();

    if (props.onClick) {
      props.onClick(props.moment);
    }
  };

  var onStarClick = function onStarClick(e) {
    e.preventDefault();
    e.stopPropagation();

    if (props.starClick) {
      props.starClick(e, props.moment);
    }
  };

  var onUserClick = function onUserClick(e) {
    e.preventDefault();
    e.stopPropagation();

    if (props.userClick) {
      props.userClick(props.moment);
    }
  };

  var onTagClick = function onTagClick(e) {
    e.preventDefault();
    e.stopPropagation();

    if (props.tagClick) {
      props.tagClick(props.moment);
    }
  };

  var getUniqueSourcecount = function getUniqueSourcecount(moment) {
    var _moment$meta, _moment$meta$camera, _moment$sources;

    var theCount = 0;
    var countMap = {}; // Add the main camera

    if ((_moment$meta = moment.meta) !== null && _moment$meta !== void 0 && (_moment$meta$camera = _moment$meta.camera) !== null && _moment$meta$camera !== void 0 && _moment$meta$camera.name) {
      countMap[moment.meta.camera.name] = true;
    } //  Add the source cameras


    if (moment !== null && moment !== void 0 && (_moment$sources = moment.sources) !== null && _moment$sources !== void 0 && _moment$sources.length) {
      var _iterator = _createForOfIteratorHelper(moment.sources),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var source = _step.value;
          countMap[source.meta.camera.name] = true;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      theCount = Object.keys(countMap).length;
    }

    return theCount;
  };

  var avatarsKlass = "none";

  if (props.players && props.players.length < 6 && props.players.length > 0) {
    avatarsKlass = "short";
  } else if (props.players && props.players.length > 5) {
    avatarsKlass = "tall";
  }

  var tagsKlass = "";

  if (!props.players || props.players.length === 0) {
    tagsKlass = "only-tags";
  } else if (props.players.length === 1) {
    tagsKlass = "single";
  } else if (props.players.length === 2) {
    tagsKlass = "double";
  } else {
    tagsKlass = "multi";
  }

  var startTime = props.moment.full_game_time ? props.moment.full_game_time : 0;
  var uniqueSourceCount = getUniqueSourcecount(props.moment);
  var showTitle = props.moment && props.moment.sport_type !== "baseball";
  var momentTitle = showTitle ? props.title : null;
  return /*#__PURE__*/_react.default.createElement(_atoms.Row, _extends({}, attr, {
    className: cn,
    padding: "4 0",
    onClick: onClick,
    background: _atoms.Color.White2
  }), /*#__PURE__*/_react.default.createElement(_atoms.Column, {
    className: "moment-time",
    padding: "2 4"
  }, props.moment.sport_type === "baseball" && /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    bold: true,
    right: true
  }, formatInning(props.moment)), props.moment.sport_type !== "baseball" && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, props.timeIsSegmentNum && /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    bold: true,
    right: true
  }, props.moment.game_segment_num, (0, _ordinalSuffix.ordinalSuffix)(props.moment.game_segment_num)), !props.timeIsSegmentNum && /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    bold: true,
    right: true
  }, formatTime(startTime)))), /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "MomentRowContent",
    span: "8"
  }, !momentTitle && /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "MomentRowContentGutter"
  }, /*#__PURE__*/_react.default.createElement(MomentTags, {
    name: "tags-preview ".concat(tagsKlass),
    tags: (0, _.generateHumanTags)(props.moment),
    homeColor: props.homeColor,
    awayColor: props.awayColor,
    sourceCount: uniqueSourceCount,
    active: props.expanded
  }), /*#__PURE__*/_react.default.createElement(MomentAvatars, {
    name: avatarsKlass,
    onClick: onUserClick,
    players: props.players,
    highlightPlayer: props.highlightPlayer,
    spotlight: props.spotlight
  }), /*#__PURE__*/_react.default.createElement(MomentTags, {
    moment: props.moment,
    name: "tags ".concat(tagsKlass),
    onClick: onTagClick,
    tags: (0, _.generateHumanTags)(props.moment),
    homeColor: props.homeColor,
    awayColor: props.awayColor,
    sourceCount: uniqueSourceCount,
    active: props.expanded
  })), momentTitle && /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "MomentRowContentGutter title"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    content: props.title,
    paddingLeft: "1",
    paddingTop: "2"
  }), /*#__PURE__*/_react.default.createElement(MomentTags, {
    moment: props.moment,
    name: "tags-preview ".concat(tagsKlass),
    tags: (0, _.generateHumanTags)(props.moment),
    homeColor: props.homeColor,
    awayColor: props.awayColor,
    sourceCount: uniqueSourceCount,
    active: props.expanded
  }))), /*#__PURE__*/_react.default.createElement(_atoms.Column, {
    spacingRight: "2"
  }, !props.title && /*#__PURE__*/_react.default.createElement(_atoms.Icon, {
    type: _atoms.Icon.Type.TraceIDEmpty,
    color: _atoms.Color.Grey3,
    onClick: onStarClick
  })));
};

exports.MomentRow = MomentRow;

var MomentAvatars = function MomentAvatars(_ref) {
  var name = _ref.name,
      onClick = _ref.onClick,
      players = _ref.players,
      highlightPlayer = _ref.highlightPlayer,
      spotlight = _ref.spotlight,
      onAvatarClick = _ref.onAvatarClick,
      avatarSize = _ref.avatarSize;

  if (!players || players.length === 0) {
    return null;
  }

  var i = 0;
  var amt;

  if (players.length === 1) {
    amt = "single";
  } else if (players.length === 2) {
    amt = "double";
  } else {
    amt = "multi";
  }

  return /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "avatars ".concat(name, " ").concat(amt)
  }, players.map(function (p) {
    i++;
    var bg = _atoms.Color.Grey3;
    var color = _atoms.Color.Grey1;
    var border = null;
    var fullName = "";

    if (p.user) {
      if (p.user.first_name) {
        fullName += p.user.first_name;
      }

      if (p.user.last_name) {
        var pre = "";

        if (fullName.length > 0) {
          pre = " ";
        }

        fullName += pre + p.user.last_name;
      }
    }

    return /*#__PURE__*/_react.default.createElement(_molecules.Avatar, {
      trkAction: "User Avatar Pressed",
      key: "avatar-".concat(i, "-").concat(p.user.user_id),
      initials: p.user.abbr,
      background: bg,
      color: color,
      border: border,
      imageUrl: p.imageUrl,
      fullName: fullName,
      touchable: !!onAvatarClick,
      marginRight: "2",
      marginTop: "1",
      marginBottom: "1",
      onClick: function onClick(e) {
        if (onAvatarClick) {
          onAvatarClick(p);
        }
      },
      size: avatarSize
    });
  }), players.length > 3 && /*#__PURE__*/_react.default.createElement(_molecules.Avatar, {
    initials: "+" + (players.length - 2),
    className: "avatar-group"
  }));
};

exports.MomentAvatars = MomentAvatars;

var MomentTags = function MomentTags(_ref2) {
  var moment = _ref2.moment,
      name = _ref2.name,
      onClick = _ref2.onClick,
      tags = _ref2.tags,
      active = _ref2.active,
      sourceCount = _ref2.sourceCount,
      homeColor = _ref2.homeColor,
      awayColor = _ref2.awayColor;
  var i = 0;
  return /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: name
  }, tags.map(function (tag) {
    var _moment$meta2;

    var useableTag = tag;
    var usableCategory = name;
    var isCameraTag = tag.name === "tracecam" || tag.name === "multi-cam" || tag.name.startsWith("phone-");

    if (isCameraTag && (moment === null || moment === void 0 ? void 0 : (_moment$meta2 = moment.meta) === null || _moment$meta2 === void 0 ? void 0 : _moment$meta2.type) !== "FullGameVideo") {
      useableTag = {
        category: "sources",
        name: "sources",
        background: _atoms.Color.WarningTint2,
        icon: _atoms.Icon.Type.Multicam,
        title: sourceCount === 0 ? 1 : sourceCount
      };
    }

    return /*#__PURE__*/_react.default.createElement(_molecules.TagChip, {
      key: "".concat(name, "-").concat(i++, "-").concat(useableTag.name),
      category: usableCategory,
      onClick: onClick,
      tag: useableTag
    });
  }));
};

exports.MomentTags = MomentTags;

var formatInning = function formatInning(moment) {
  var value = "?th";
  var inningTag = moment.tags.find(function (tag) {
    return tag.name.includes("inning");
  });

  if (inningTag) {
    var inningText = inningTag.name.replace("inning-", "");
    value = (0, _format.format)(inningText, _format.Formats.Ordinal);
  }

  return value;
};

var formatTime = function formatTime(time) {
  var m = 0;
  var s = 0;
  var total = time;
  m = Math.floor(total / 60);
  total = total - m * 60;
  s = Math.floor(total);

  if (s < 10) {
    s = "0".concat(s);
  }

  return "".concat(m, ":").concat(s);
};

MomentRow.propTypes = {
  /* The moment that you want to display */
  moment: _propTypes.default.shape({
    duration: _propTypes.default.number,
    half: _propTypes.default.number,
    time: _propTypes.default.number,
    utc_time: _propTypes.default.number,
    game_clip_id: _propTypes.default.number,
    game_id: _propTypes.default.number,
    team_id: _propTypes.default.number,
    user_playlist_key: _propTypes.default.string,
    dynamic: _propTypes.default.shape({
      audio: _propTypes.default.string,
      duration: _propTypes.default.number,
      hls: _propTypes.default.string,
      jfile: _propTypes.default.string,
      offset: _propTypes.default.number,
      start: _propTypes.default.number
    }),
    meta: _propTypes.default.shape({
      all_trace_numbers: _propTypes.default.array,
      thirds: _propTypes.default.array,
      trace_numbers: _propTypes.default.array,
      type: _propTypes.default.string,
      uuid: _propTypes.default.string
    })
  }),

  /* will display game_segment_num property instead of game time */
  timeIsSegmentNum: _propTypes.default.bool,

  /* Array of players to show for this moment */
  players: _propTypes.default.array,

  /* User id of the player to highlight in this row */
  highlightPlayer: _propTypes.default.number,

  /* When true the hightlight player will have a Color.Warning border */
  spotlight: _propTypes.default.bool,

  /* Array of tags to show for this moment */
  tags: _propTypes.default.array,

  /* Is this row expanded */
  expanded: _propTypes.default.bool,

  /* row click event handler */
  onClick: _propTypes.default.func,

  /* star button click handler */
  onStarClick: _propTypes.default.func,

  /* tag click handler */
  onTagClick: _propTypes.default.func,

  /* user click handler */
  onUserClick: _propTypes.default.func
};